import type { PropsWithOptionalChildren } from '@shared/utils';
import { UserDetailsFormModal } from '@user-management/user-details';
import { createContext, useCallback, useMemo, useState } from 'react';

import type { UserManagementListModalContextValue, UserManagementListModalAction } from './types';

const UserManagementListModalContext = createContext<
  UserManagementListModalContextValue | undefined
>(undefined);

export default function UserManagementListModalProvider(
  props: Readonly<PropsWithOptionalChildren>,
) {
  const { children } = props;
  const [action, setAction] = useState<UserManagementListModalAction | null>(null);
  const [id, setId] = useState<string | null>(null);

  const handleSetAction = useCallback(
    (action: UserManagementListModalAction | null, id: string | null = null) => {
      setAction(action);
      setId(id);
    },
    [setAction],
  );

  const handleClose = useCallback(() => {
    setAction(null);
    setId(null);
  }, []);

  const contextValue: UserManagementListModalContextValue = useMemo(() => {
    return {
      setAction: handleSetAction,
      close: handleClose,
    };
  }, [handleSetAction, handleClose]);

  return (
    <UserManagementListModalContext.Provider value={contextValue}>
      {children}
      {action === 'edit' && id ? <UserDetailsFormModal id={id} open onClose={handleClose} /> : null}
    </UserManagementListModalContext.Provider>
  );
}

export { UserManagementListModalContext };
